const CommunicationMethod = Object.freeze({
    EMAIL: 'Email',
    SMS: 'SMS'
})

export default CommunicationMethod